import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
const UpdateVistas = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
      };
    useEffect(() => {
        const handleScroll = () => {
            const header = document.querySelector('.vistasHeader');
            if (window.scrollY > 50) {
                header?.classList.add('smallHeader');
            } else {
                header?.classList.remove('smallHeader');
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    var settings = {
        dots: false,
        infinite: true,
        fade: true,
        speed: 500,
        slidesToShow: 1,
        autoplaySpeed: 2000,
        autoplay: true,
        slidesToScroll: 1
    
      };
    return(
        <>
        <div className="vistasHeader">
            <div className="vistas-logo">
                <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/vistas-logo.png" className="img-fluid" alt="Lotus Valley School, Gurgaon" />
            </div>
            <div className="hamburger" onClick={toggleMenu}>
                {menuOpen ?'✖' : '☰'}
         
        </div>
        <ul className={`vistas-menu ${menuOpen ? 'open' : ''}`}>
                <li><Link to="/vistas">Introduction</Link></li>
                <li><Link to="/counselling-vistas">Counselling</Link></li>
                <li><Link to="/upcomingevt-vistas">Upcoming Events</Link></li>     
                <li><Link to="/update-vistas">Updates</Link></li>     
                <li><Link to="/spotlight-vistas">Spotlight</Link></li>     
                <li><Link to="/connect-vistas">Connect with Us</Link></li>     
            </ul>
        </div>
        <div className="slider-vistas">
        <Slider {...settings}>
          <div><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/vistas1.jpg" alt="Lotus Valley Gurgaon" className="img-fluid" /> </div>
          <div><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/vistas2.jpg" alt="Lotus Valley Gurgaon" className="img-fluid" /> </div>
          <div><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/vistas3.jpg" alt="Lotus Valley Gurgaon" className="img-fluid" /> </div>
          <div><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/vistas4.jpg" alt="Lotus Valley Gurgaon" className="img-fluid" /> </div>
          <div><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/vistas5.jpg" alt="Lotus Valley Gurgaon" className="img-fluid" /> </div>
          <div><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/vistas6.jpg" alt="Lotus Valley Gurgaon" className="img-fluid" /> </div>
          <div><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/vistas7.jpg" alt="Lotus Valley Gurgaon" className="img-fluid" /> </div>
          <div><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/vistas8.jpg" alt="Lotus Valley Gurgaon" className="img-fluid" /> </div> 
        </Slider>
        </div>
        <div className='padding-wid vistas_p'>
        <div class="container">
            <div class="text-center d-block">
                <h3 class="mx-auto text-black mb-4 font-play">Updates</h3>
            </div>
            <div class="row">
                <div class="col-md-12 textarea">
                    <section>
                        <ul class="list font-play">
                            <li> COMMUNITY WARRIORS SUMMER INTERNSHIP PROGRAMME at GOOJ - <a href="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/Goonj.pdf" target="_blank" class="text-primary">Click Here</a></li>
                            <li>FORTIS PROSOCIAL PEER MODERATOR PROGRAMME - <a href="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/FORTIS_PEER-MODERATOR.pdf" target="_blank" class="text-primary">Click Here</a></li>

                        </ul>
                    </section>
                </div>

            </div>
        </div>
        </div>
        <div className='copyright-vistas'>
                © 2024 All rights reserved with Lotus Valley School, Gurgaon
            </div>
        </>
    )

}
export default UpdateVistas